import * as React from "react";
const SvgMicrosoft = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 20h10v-9H10v9ZM0 20h9v-9H0v9Zm10-10h10V0H10v10ZM0 10h9V0H0v10Z", fill: "currentColor", fillRule: "evenodd" })));
export default SvgMicrosoft;
